import { render, staticRenderFns } from "./WindowLogbox.vue?vue&type=template&id=c2677a70&scoped=true&"
import script from "./WindowLogbox.vue?vue&type=script&lang=js&"
export * from "./WindowLogbox.vue?vue&type=script&lang=js&"
import style0 from "./WindowLogbox.vue?vue&type=style&index=0&id=c2677a70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2677a70",
  null
  
)

export default component.exports